import { SHOW_CALENDER } from "./actionTypes";

export const showCalender = (data) => {
  return {
    type: SHOW_CALENDER,
    payload: data,
  };
};
